import * as React from "react";
import { View, Text, StyleSheet } from "react-native";
import translation from "../../translations/translation";
import { currentLanguage } from "../../translations/CurrentLanguage";
import LocalizedStrings from "react-native-localization";
import { colors, formatMoney } from "../../theme/modern";

let strings = new LocalizedStrings(translation);

const taxLabel = props =>
  parseFloat(props.receipt.taxesValue) > 0 && props.enableOverallTax
    ? ` (${props.receipt.taxesValue.toString()}%)`
    : "";

const discountLabel = ({ receipt }) => {
  if (!receipt || !(receipt.discountValue > 0)) {
    return "";
  }
  if (receipt.discountType === "percentage") {
    return ` (${(receipt.discountValue * 100).toString()}%)`;
  }
  return ` (${receipt.discountValue})`;
};

const TotalLineComponent = props => {
  strings.setLanguage(currentLanguage().companyLanguage);
  const money = value =>
    formatMoney(value, props.currency, props.isCurrencyDisabled);

  return (
    <View style={styles.container}>
      <View style={styles.row}>
        <Text style={styles.label}>{strings.Subtotal}</Text>
        <Text style={styles.value}>{money(props.subtotal)}</Text>
      </View>
      <View style={styles.row}>
        <Text style={styles.label}>
          {strings.Tax}
          {taxLabel(props)}
        </Text>
        <Text style={styles.value}>{money(props.taxesValue)}</Text>
      </View>
      <View style={styles.row}>
        <Text style={styles.label}>
          {strings.Discounts}
          {discountLabel(props)}
        </Text>
        <Text style={styles.value}>{money(props.discount)}</Text>
      </View>
      <View style={[styles.row, styles.totalRow]}>
        <Text style={styles.totalLabel}>{strings.TotalPayment}</Text>
        <Text style={styles.totalValue}>{money(props.totalPayment)}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
    paddingTop: 12,
    paddingBottom: 4,
    borderTopWidth: 1,
    borderTopColor: colors.border,
    backgroundColor: colors.surface,
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 3,
  },
  label: {
    fontSize: 14,
    color: colors.textMuted,
  },
  value: {
    fontSize: 14,
    fontWeight: "600",
    color: "#334155",
  },
  totalRow: {
    marginTop: 8,
    paddingTop: 10,
    borderTopWidth: 1,
    borderTopColor: colors.border,
  },
  totalLabel: {
    fontSize: 16,
    fontWeight: "700",
    color: colors.text,
  },
  totalValue: {
    fontSize: 20,
    fontWeight: "700",
    color: colors.primary,
  },
});

export default TotalLineComponent;
